var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_718_79727)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00005 0.800781C4.0236 0.800781 0.800049 4.02433 0.800049 8.00078C0.800049 11.9772 4.0236 15.2008 8.00005 15.2008C11.9765 15.2008 15.2 11.9772 15.2 8.00078C15.2 4.02433 11.9765 0.800781 8.00005 0.800781ZM5.82431 4.97652C5.59 4.7422 5.2101 4.7422 4.97578 4.97652C4.74147 5.21083 4.74147 5.59073 4.97578 5.82505L7.15152 8.00078L4.97578 10.1765C4.74147 10.4108 4.74147 10.7907 4.97578 11.025C5.2101 11.2594 5.59 11.2594 5.82431 11.025L8.00005 8.84931L10.1758 11.025C10.4101 11.2594 10.79 11.2594 11.0243 11.025C11.2586 10.7907 11.2586 10.4108 11.0243 10.1765L8.84858 8.00078L11.0243 5.82505C11.2586 5.59073 11.2586 5.21083 11.0243 4.97652C10.79 4.7422 10.4101 4.7422 10.1758 4.97652L8.00005 7.15225L5.82431 4.97652Z",
    fill: "#E70E0E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_718_79727"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.118a8775a0fbcc7675b566e4bddbdbf9.svg";
export { ForwardRef as ReactComponent };